export const assetStateUrl = (assetId: string) => `asset-state/historic/${assetId}/`;
